export const logoutType = 'logoutType';

export const Licenses = {
  Reaxys: 'Reaxys:Reaxys',
  ReaxysMedChem: 'Reaxys:ReaxysMedChem',
  Both: 'Reaxys:Both',
};

export const SessionExpiredMessage = 'Your session has expired';
